import { WEBCHAT_CUSTOMER_IDENTIFIER_PREFIX } from 'modules/webchat/domain/constants';
import { IWebchatIdentity } from 'modules/webchat/domain/entities';

type TCustomerSession = { id: number; name?: string } | null | undefined;

/** Dados do cadastro que completam a identidade (o celular não vem na sessão). */
type TCustomerProfile = { phone?: string } | null | undefined;

/**
 * Só a sessão completa (senha ou Google) identifica o cliente no chat. O
 * login feito só com CPF (guestId) não serve: quem digitasse o CPF de outra
 * pessoa apareceria para o atendente como esse cliente.
 */
export default function buildCustomerWebchatIdentity(
  session: TCustomerSession,
  profile?: TCustomerProfile,
): IWebchatIdentity | null {
  if (!session?.id) return null;

  const identity: IWebchatIdentity = {
    identifier: `${WEBCHAT_CUSTOMER_IDENTIFIER_PREFIX}${session.id}`,
    customerId: session.id,
  };

  if (session.name) identity.name = session.name;

  if (profile?.phone) identity.phone = profile.phone;

  return identity;
}
